
import React, { useState, useEffect } from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { 
  Link,
  Database
} from 'lucide-react';
import ConnectionSettings from '@/components/settings/ConnectionSettings';
import IntegrationSettings from '@/components/settings/IntegrationSettings';
import ChatBotButton from '@/components/chat/ChatBotButton';
import { useAuth } from '@/context/AuthContext';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('connections');
  const { user } = useAuth();
  
  // Update activeTab when component mounts to ensure it's a visible tab
  useEffect(() => {
    if (activeTab !== 'connections' && activeTab !== 'integrations') {
      setActiveTab('connections');
    }
  }, [activeTab]);
  
  return (
    <DashboardLayout>
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800 dark:text-white">Settings</h1>
        <div className="flex items-center mt-2">
          <p className="text-gray-500 dark:text-gray-400">Configure your governance platform preferences and integrations</p>
          <div className="ml-auto flex items-center bg-gray-100 dark:bg-gray-800 rounded-full px-4 py-2">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Logged User: </span>
            <span className="text-sm font-bold text-indigo-600 dark:text-indigo-400 ml-2">{user?.email || 'Guest User'}</span>
          </div>
        </div>
      </div>
      
      {/* Tabs using shadcn UI Tabs component */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="mb-8 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
          <TabsTrigger value="connections" className="flex items-center px-6 py-4 text-sm font-medium whitespace-nowrap">
            <Link className="h-4 w-4 mr-2" />
            Connections
          </TabsTrigger>
          <TabsTrigger value="integrations" className="flex items-center px-6 py-4 text-sm font-medium whitespace-nowrap">
            <Database className="h-4 w-4 mr-2" />
            Integrations
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="connections" className="mt-6">
          <ConnectionSettings />
        </TabsContent>
        
        <TabsContent value="integrations" className="mt-6">
          <IntegrationSettings />
        </TabsContent>
      </Tabs>
      
      {/* Add ChatBot Button */}
      <ChatBotButton />
    </DashboardLayout>
  );
};

export default Settings;
